
const dispatchWishlistUpdate = (numberOfItems: number) => {
    let event = new CustomEvent('ChannelsWishlistUpdate', {
        detail: {
            numberOfItems: numberOfItems,
        }
    });
    window.dispatchEvent(event)
}

export {
    dispatchWishlistUpdate
}